// src/catalog/components/detail/CatalogEntryLinksPanel.jsx

import { formatLabel } from "../../utils/catalogDisplay";

export default function CatalogEntryLinksPanel({
  externalLinks = []
}) {
  if (externalLinks.length === 0) {
    return null;
  }

  return (
    <div className="catalog-detail__panel">
      <h2>Related links</h2>

      <div className="catalog-detail__links">
        {externalLinks.map((link) => (
          <a
            key={`${link.type}-${link.url}`}
            href={link.url}
            target="_blank"
            rel="noopener noreferrer"
          >
            {link.label || formatLabel(link.type) || "External link"}
          </a>
        ))}
      </div>
    </div>
  );
}
